import request from '@/utils/request';

// 定义用户接口类型
export interface User {
  id: number;
  username: string;
  email: string;
  phone: string;
  status: number; // 0-禁用，1-正常
  role: string;
  roleId: number;
  createTime: string;
  password?: string;
  updatingStatus?: boolean; // 添加状态更新标记
}

export interface UserListParams {
  pageNum: number;
  pageSize: number;
  username?: string | null;
  status?: number | null;
  roleId?: number | null;
}

export interface UpdateUserStatusParams {
  userId: number;
  status: number; // 0-禁用，1-正常
}

export interface UpdateUserInfoParams {
  userId: number;
  username: string;
  email: string;
  phone: string;
  roleId: number;
  status: number;
}

export interface AddUserParams {
  username: string;
  password: string;
  name: string;
  email: string;
  phone: string;
  roleId: number;
  status: number;
}

/**
 * 获取用户列表（分页）
 */
export function getUserList(params: UserListParams) {
  return request({
    url: '/admin/user/list',
    method: 'post',
    data: params
  });
}

/**
 * 获取当前用户信息
 */
export const getCurrentUserInfo = () => {
  return request({
    url: '/admin/auth/info',
    method: 'get'
  });
};

/**
 * 退出登录
 */
export const logout = () => {
  return request({
    url: '/admin/auth/logout',
    method: 'post'
  });
};

/**
 * 更新用户状态
 */
export function updateUserStatus(params: UpdateUserStatusParams) {
  return request({
    url: '/admin/user/updatestatus',
    method: 'put',
    data: params
  });
}

/**
 * 重置用户密码
 */
export function resetUserPassword(userId: number) {
  return request({
    url: `/admin/user/${userId}`,
    method: 'put'
  });
}

/**
 * 更新用户信息
 */
export function updateUserInfo(params: UpdateUserInfoParams) {
  return request({
    url: '/admin/user/update',
    method: 'put',
    data: params
  });
}

/**
 * 添加用户
 */
export function addUser(params: AddUserParams) {
  return request({
    url: '/admin/user/add',
    method: 'post',
    data: params
  });
}

/**
 * 删除用户
 */
export function deleteUser(userId: number) {
  return request({
    url: `/admin/user/${userId}`,
    method: 'delete'
  });
}